import React from 'react';
import { motion } from 'framer-motion';
import './InventoryInsightCard.css';

interface InventoryInsightCardProps {
  title: string;
  count: number;
  subtitle: string;
  icon: string;
  severity: 'critical' | 'warning' | 'info';
  onClick?: () => void;
}

const InventoryInsightCard: React.FC<InventoryInsightCardProps> = ({
  title,
  count,
  subtitle,
  icon,
  severity,
  onClick,
}) => {
  const getSeverityClass = () => {
    switch (severity) {
      case 'critical':
        return 'critical';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  };

  const getSeverityIcon = () => {
    switch (severity) {
      case 'critical':
        return 'bx-error-circle';
      case 'warning':
        return 'bx-alert-triangle';
      case 'info':
        return 'bx-info-circle';
      default:
        return 'bx-info-circle';
    }
  };

  return (
    <motion.div
      className={`inventory-insight-card ${getSeverityClass()}`}
      onClick={onClick}
      whileHover={{ scale: 1.02, y: -4 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="insight-header">
        <div className={`insight-icon ${getSeverityClass()}`}>
          <i className={`bx ${icon}`}></i>
        </div>
        <div className={`severity-badge ${getSeverityClass()}`}>
          <i className={`bx ${getSeverityIcon()}`}></i>
          <span>{severity}</span>
        </div>
      </div>

      <div className="insight-content">
        <h3 className="insight-title">{title}</h3>
        <div className="insight-count">{count}</div>
        <p className="insight-subtitle">{subtitle}</p>
      </div>

      <div className="insight-footer">
        <button className="btn-view-more">
          View List
          <i className="bx bx-chevron-right"></i>
        </button>
      </div>
    </motion.div>
  );
};

export default InventoryInsightCard;
